import { Body2, Flex } from '@sainsburys-tech/fable'
import { AlertCircleFilled } from '@sainsburys-tech/icons'
import React from 'react'

import { FormErrorMessageKey } from '../../enums/FormErrorMessageKey'
import { FormErrorMessages } from '../../utils/FormErrorMessages'

interface TemperatureCheckErrorMessageProps {
  class: string
  messageKey: FormErrorMessageKey
}

const TemperatureCheckErrorMessage = (
  props: TemperatureCheckErrorMessageProps,
) => (
  <Flex alignItems='center'>
    <span className={`${props.class}`}>
      <AlertCircleFilled className='c-common-error_icon-red' />
    </span>
    <span className={props.class}>
      <Body2>{FormErrorMessages.get(props.messageKey)}</Body2>
    </span>
  </Flex>
)

export default TemperatureCheckErrorMessage
